import baseStyles from '../Base/Base.styles'
import BaseRatingStyles from '../BaseRating/BaseRating.styles'

export default ({ base, ratingEmptyColor, ratingFilledColor, textColor, authorColor}) => {
  return {
    root: {
      ...baseStyles(base),
      ...BaseRatingStyles({
        emptyColor: ratingEmptyColor,
        filledColor: ratingFilledColor,
        size: 10,
      }),
      padding: '32px',
      display: 'grid',
      gridGap: '32px',
      
      '& .author': { marginBottom: '8px', color: authorColor },

      '& .author-location': { fontWeight: 'normal' },
      
      '& .review-text': {
        marginTop: '8px',
        fontWeight: 'normal',
        opacity: 0.7,
        color: textColor
      }
    }
  }
}
